import { ACTIVITY_STAGES } from "../activitySectionUtils";
export const BUILDER_SECTIONS = [
  {
    id: "general",
    name: "General Information",
    shortName: "General",
    icon: "fi fi-rr-info",
    stage: ACTIVITY_STAGES.GENERAL,
    unlockOrder: 1,
    essential: true,
    tooltip: "Name, category, location, description, thumbnail, cover image, and gallery photos",
  },
  {
    id: "tickets",
    name: "Ticket Types",
    shortName: "Tickets",
    icon: "fi fi-rr-ticket",
    stage: ACTIVITY_STAGES.TICKETS,
    unlockOrder: 2,
    essential: true,
  },
  {
    id: "availability",
    name: "Availability",
    shortName: "Availability",
    icon: "fi fi-rr-calendar-clock",
    stage: ACTIVITY_STAGES.ITINERARY,
    unlockOrder: 3,
    essential: true,
  },
  {
    id: "pricing",
    name: "Pricing",
    shortName: "Pricing",
    icon: "fi fi-rr-dollar",
    stage: ACTIVITY_STAGES.PRICING,
    unlockOrder: 4,
    essential: true,
    hiddenWhenFreeBooking: true,
  },
  {
    id: "faq",
    name: "FAQ",
    shortName: "FAQ",
    icon: "fi fi-rr-interrogation",
    stage: ACTIVITY_STAGES.FAQ,
    unlockOrder: 5,
    essential: true,
  },
  {
    id: "terms",
    name: "Terms & Conditions",
    shortName: "Terms",
    icon: "fi fi-rr-memo-circle-check",
    stage: ACTIVITY_STAGES.TERMS,
    unlockOrder: 6,
    essential: true,
  },
];

export const getVisibleBuilderSections = (isFreeBooking) =>
  BUILDER_SECTIONS.filter(
    (s) => !(s.hiddenWhenFreeBooking && isFreeBooking)
  );